class ProductCard extends CustomElement {
    props = {
        productId: ""
    }

    constructor() {
        super()
    }
}

customElements.define('product-card', ProductCard);

// class ProductStarRating extends CustomElement {
//     props = {
//         productId: ""
//     }
//     constructor() {
//         super()
//     }

//     mounted() {
//         super.mounted();

//         this.getReview()
//     }

//     getReview() {
//         const {productId} = this.props;
//         const url = `https://api.yotpo.com/products/hkKfI5hCtFBa1R1pOQSilnSXskIQjwamdfXvlcBu/${productId}/bottomline`;

//         const options = {
//             method: 'GET',
//             headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
//         };

//         fetch(url, options)
//             .then(res => res.json())
//             .then(json => json.response.bottomline)
//             .then(res => {
//                 if (res.average_score > 0) this.innerHTML=`<star-rating :id="${productId}" :score="${res.average_score}">`
//             })
//             .catch(err => console.error('error:' + err));
//     }
// }

// customElements.define('product-star-rating', ProductStarRating);
